import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { iStore } from '~/domain/interfaces/models';

export interface PrivateRouteType {
  component: React.FC;
  path: string;
  exact?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteType> = (
  props: PrivateRouteType,
) => {
  const { access } = useSelector((state: iStore) => state.auth);
  const { component, path, exact } = props;

  return access.token ? (
    <Route path={path} exact={exact} component={component} />
  ) : (
    <Redirect to="/" />
  );
};

export default PrivateRoute;
